import { AnyPrice, TranslatedString } from "@ct-react/core";

export enum AgeCategory {
  ADULT = "ADULT",
  BABY = "BABY",
  CHILD = "CHILD",
  SENIOR = "SENIOR",
  EXEMPT = "EXEMPT"
}

type IEditorialCartOptionDef = {
  optionId: string;
  title: TranslatedString;
  description?: TranslatedString;
  images: string[];
  forceSelection: boolean;
}

type IBenefitCartOptionDef = {
  criteria: { quantity: number[] },
  grid: BenefitCartOptionGridItem[];
}

export type BenefitCartOptionGridItem = {
  quantity: number;
  price: AnyPrice;
}

export type BenefitCartOption = IEditorialCartOptionDef & IBenefitCartOptionDef;
export type AnyCartOption = BenefitCartOption;
